module.exports = __webpack_public_path__ + "img/20190805161844432.0a081fa3.png";